import { db } from "../firebase";
import {
  addDoc,
  collection,
  doc,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  updateDoc
} from "firebase/firestore";

const cleanText = (value) => String(value || "").trim();

const normalizeBranches = (branches) =>
  (Array.isArray(branches) ? branches : []).map((branch) => ({
    id: cleanText(branch.id) || crypto.randomUUID(),
    name: cleanText(branch.name),
    technoparkName: cleanText(branch.technoparkName),
    address: cleanText(branch.address),
    startDate: cleanText(branch.startDate),
    endDate: cleanText(branch.endDate),
    portalUrl: cleanText(branch.portalUrl),
    isActive: branch.isActive !== false
  }));

export const subscribeCompanies = (callback) => {
  const companiesQuery = query(collection(db, "companies"), orderBy("shortName", "asc"));

  return onSnapshot(companiesQuery, (snapshot) => {
    callback(snapshot.docs.map((item) => ({ id: item.id, ...item.data() })));
  });
};

export const createCompany = async (data) => {
  const legalName = cleanText(data.legalName);
  if (!legalName) throw new Error("Ticari unvan zorunludur.");

  return addDoc(collection(db, "companies"), {
    legalName,
    shortName: cleanText(data.shortName) || legalName,
    taxNumber: cleanText(data.taxNumber),
    taxOffice: cleanText(data.taxOffice),
    mersisNumber: cleanText(data.mersisNumber),
    cariCode: cleanText(data.cariCode),
    paymentTermDays: Number(data.paymentTermDays || 0),
    currency: cleanText(data.currency) || "TRY",
    phone: cleanText(data.phone),
    email: cleanText(data.email).toLowerCase(),
    website: cleanText(data.website),
    address: cleanText(data.address),
    notes: cleanText(data.notes),
    branches: normalizeBranches(data.branches),
    isActive: data.isActive !== false,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp()
  });
};

export const updateCompany = async (companyId, data) => {
  if (!companyId) throw new Error("Firma kaydı bulunamadı.");
  const legalName = cleanText(data.legalName);
  if (!legalName) throw new Error("Ticari unvan zorunludur.");

  return updateDoc(doc(db, "companies", companyId), {
    legalName,
    shortName: cleanText(data.shortName) || legalName,
    taxNumber: cleanText(data.taxNumber),
    taxOffice: cleanText(data.taxOffice),
    mersisNumber: cleanText(data.mersisNumber),
    cariCode: cleanText(data.cariCode),
    paymentTermDays: Number(data.paymentTermDays || 0),
    currency: cleanText(data.currency) || "TRY",
    phone: cleanText(data.phone),
    email: cleanText(data.email).toLowerCase(),
    website: cleanText(data.website),
    address: cleanText(data.address),
    notes: cleanText(data.notes),
    branches: normalizeBranches(data.branches),
    isActive: data.isActive !== false,
    updatedAt: serverTimestamp()
  });
};

export const archiveCompany = async (companyId) => {
  if (!companyId) throw new Error("Firma kaydı bulunamadı.");

  return updateDoc(doc(db, "companies", companyId), {
    isActive: false,
    updatedAt: serverTimestamp()
  });
};
